// extracted by mini-css-extract-plugin
export var footer = "_pd-5";
export var fulfillmentInput = "_pd-0";
export var shipDateInput = "_pd-1";
export var shipmentModal = "_pd-2";
export var shipmentModalContent = "_pd-3";
export var tableContainer = "_pd-4";